import React, { useState, useCallback } from "react";
import "./Conversor.css";

const Conversor = () => {
  const [moedaA, setMoedaA] = useState("EUR");
  const [moedaB, setMoedaB] = useState("BRL");
  const [valor, setValor] = useState("");
  const [resultado, setResultado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");
  const [historico, setHistorico] = useState([]);

  const moedas = [
    { codigo: "BRL", nome: "Real Brasileiro" },
    { codigo: "USD", nome: "Dólar Americano" },
    { codigo: "EUR", nome: "Euro" },
    { codigo: "JPY", nome: "Iene Japonês" },
    { codigo: "GBP", nome: "Libra Esterlina" },
    { codigo: "CAD", nome: "Dólar Canadense" },
    { codigo: "AUD", nome: "Dólar Australiano" },
    { codigo: "CHF", nome: "Franco Suíço" },
    { codigo: "CNY", nome: "Yuan Chinês" },
    { codigo: "INR", nome: "Rupia Indiana" },
  ];

  const converter = useCallback(
    async (valorParam, moedaAParam, moedaBParam) => {
      const v = valorParam || valor;
      const a = moedaAParam || moedaA;
      const b = moedaBParam || moedaB;

      if (!v || v <= 0) {
        setErro("Por favor, digite um valor válido");
        setResultado(null);
        return;
      }

      setLoading(true);
      setErro("");

      try {
        const response = await fetch(
          `https://api.exchangerate-api.com/v4/latest/${a}`,
        );
        if (!response.ok) throw new Error("Erro ao buscar dados");

        const data = await response.json();
        if (!data.rates[b]) throw new Error("Moeda não encontrada");

        const taxa = data.rates[b];
        const resultadoCalc = (v * taxa).toFixed(2);
        setResultado(resultadoCalc);

        // Adiciona ao histórico
        const novaConversao = {
          id: Date.now(),
          de: a,
          para: b,
          valor: v,
          resultado: resultadoCalc,
          taxa: taxa.toFixed(4),
          data: new Date().toLocaleTimeString("pt-BR"),
        };
        setHistorico((prev) => [novaConversao, ...prev.slice(0, 4)]);
      } catch (error) {
        setErro("Erro ao buscar taxa de câmbio. Tente novamente.");
        setResultado(null);
        console.error("Erro:", error);
      } finally {
        setLoading(false);
      }
    },
    [valor, moedaA, moedaB],
  );

  const inverterMoedas = () => {
    const temp = moedaA;
    const novaA = moedaB;
    const novaB = temp;
    setMoedaA(novaA);
    setMoedaB(novaB);
    setResultado(null);
    setErro("");
    // Reconverte automaticamente se houver valor
    if (valor) {
      setTimeout(() => converter(valor, novaA, novaB), 100);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      converter();
    }
  };

  const formatarValor = (valor, moeda) => {
    const opcoes = {
      style: "currency",
      currency: moeda,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    return new Intl.NumberFormat("pt-BR", opcoes).format(valor);
  };

  const limparHistorico = () => {
    setHistorico([]);
  };

  return (
    <div className="conversor-container">
      <div className="conversor-card">

        <div className="input-container">
          <div className="moedas-container">
            <div className="moeda-group">
              <label htmlFor="moedaA"></label>
              <select
                id="moedaA"
                value={moedaA}
                onChange={(e) => {
                  setMoedaA(e.target.value);
                  setResultado(null);
                  setErro("");
                }}
                className="moeda-select"
              >
                {moedas.map((m) => (
                  <option key={m.codigo} value={m.codigo}>
                    {m.nome} ({m.codigo})
                  </option>
                ))}
              </select>
            </div>

            <button
              onClick={inverterMoedas}
              className="inverter-btn"
              title="Inverter moedas"
            >
              ⇅
            </button>

            <div className="moeda-group">
              <label htmlFor="moedaB"></label>
              <select
                id="moedaB"
                value={moedaB}
                onChange={(e) => {
                  setMoedaB(e.target.value);
                  setResultado(null);
                  setErro("");
                }}
                className="moeda-select"
              >
                {moedas.map((m) => (
                  <option key={m.codigo} value={m.codigo}>
                    {m.nome} ({m.codigo})
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="input-group">
            <label htmlFor="valor"></label>
            <input
              id="valor"
              className="input-value"
              type="number"
              value={valor}
              onChange={(e) => {
                setValor(e.target.value);
                setErro("");
              }}
              placeholder="0.00"
              onKeyDown={handleKeyPress}
              min="0"
              step="0.01"
            />
          </div>
        </div>

        <button
          onClick={() => converter()}
          className="converter-btn"
          disabled={loading || !valor}
        >
          {loading ? "Convertendo..." : "Converter"}
        </button>

        {erro && <div className="erro-mensagem">⚠️ {erro}</div>}

        {resultado && (
          <div className="resultado-container">
            <h2 className="resultado-titulo">Resultado</h2>
            <p className="resultado-valor">{formatarValor(valor, moedaA)}</p>
            <p className="resultado-sinal">=</p>
            <p className="resultado-valor-destino">
              {formatarValor(resultado, moedaB)}
            </p>
            <p className="taxa-cambio">
              Taxa: 1 {moedaA} = {resultado && (resultado / valor).toFixed(4)}{" "}
              {moedaB}
            </p>
          </div>
        )}

        {historico.length > 0 && (
          <div className="historico-container">
            <div className="historico-header">
              <h3>Últimas Conversões</h3>
              <button onClick={limparHistorico} className="limpar-btn">
                Limpar
              </button>
            </div>
            <div className="historico-list">
              {historico.map((item) => (
                <div key={item.id} className="historico-item">
                  <span className="historico-moedas">
                    {item.de} → {item.para}
                  </span>
                  <span className="historico-valor">
                    {formatarValor(item.valor, item.de)} ={" "}
                    {formatarValor(item.resultado, item.para)}
                  </span>
                  <span className="historico-hora">{item.data}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Conversor;
